import React from 'react';
import classNames from 'classnames/bind';
import { noop } from '@beef/utils';
import { SearchField } from '@carnica/ui-kit';
import { useEventListener } from '@beef/react';
import { decorateHandler } from "../../../../metric";
import style from "./styles.pcss";
var cn = classNames.bind(style);
var onInputMetricClick = function onInputMetricClick() {
  decorateHandler(noop, {
    headerMetric: ['handleSearchRegionClick']
  })();
};
export var Search = function Search(_ref) {
  var searchValue = _ref.searchValue,
    setSearchValue = _ref.setSearchValue,
    onSearchChange = _ref.onSearchChange;
  var inputRef = React.useRef(null);
  useEventListener('click', onInputMetricClick, inputRef);
  var handleSearchChange = React.useCallback(function (value) {
    setSearchValue(value);
    if (value && typeof onSearchChange === 'function') {
      onSearchChange(value);
    }
  }, [setSearchValue, onSearchChange]);
  var handleSearchClear = React.useCallback(function () {
    var _inputRef$current;
    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
    decorateHandler(function () {
      return setSearchValue('');
    }, {
      headerMetric: ['handleClearSearchRegionClick']
    })();
  }, [setSearchValue]);
  return /*#__PURE__*/React.createElement("div", {
    className: cn('search-wrapper')
  }, /*#__PURE__*/React.createElement(SearchField, {
    autoFocus: true,
    className: cn('search'),
    inputRef: inputRef,
    invert: true,
    onChange: handleSearchChange,
    onClear: handleSearchClear,
    placeholder: "\u043F\u043E\u0438\u0441\u043A \u0440\u0435\u0433\u0438\u043E\u043D\u0430",
    value: searchValue
  }));
};